import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_QuarterlyBehaviour = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_QuarterlyBehaviour' className='file-pdf-document'>
            <div className='file-template'>


                <table>

                    <tr>
                        <td className="w-450"> <span className="eleHeader"> Individual Name</span>
                        </td>
                        <td className="w-300"> <span className="eleHeader"> Date last seen Psychiatrist</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-450">  <input type='text' id="txtIndividualName" name="txtIndividualName" className="add-only " /> </td>
                        <td className="w-300"> <input type='date' id="txtDatePsychiatrist" name="txtDatePsychiatrist" className="add-only " />  </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className="w-450">
                            <span className="eleHeader">Is Individual compliant with Medication Management?</span>
                        </td>
                        <td className="w-300">
                            <span className="eleHeader">Date last seen Psychiatrist</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-450">
                            <input type="radio" id="rbCompliant_Y" name="rbCompliant" className="add-only" value="Y" /> Yes
                            &nbsp;
                            <input type="radio" id="rbCompliant_N" name="rbCompliant" className="add-only" value="N" /> No
                        </td>
                        <td className="w-300">
                            <input type='date' id="rbPsychLastSeen" name="rbPsychLastSeen" className="add-only " />
                            <span className='view-only rbPsychLastSeen'></span>
                        </td>
                    </tr>
                </table>
                <p>
                    <h3>Please provide detailed information regarding Individual's behaviors over the
                        past 3 months. Please discuss the following in paragraph form.</h3>
                </p>

                <p>
                    <span className="eleHeader">Presenting Problem</span>
                    <span className="small block">(please indicate frequency in which behaviors/symptoms occur per week, triggers for onset, how
                        Presenting Problem has affected areas of daily living, i.e., self, school, work, family, community, etc.?) </span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">History of Presenting Problem</span>
                    <span className="small block">(please indicate specific details as it relate to timeframes, frequency, reason for
                        onset, previous methods in which Individual has made attempt to overcome challenges, etc.) </span>
                    <textarea id="txtPresentingProblem_Hx" name="txtPresentingProblem_Hx" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Risk of Harm</span>
                    <span className="small block">(has Individual made suicidal/homicidal ideations or threats?: If so, when was the last occurrence, history
                        of SI/HI frequency, what triggered the ideation/threat? What steps were taken to resolve the situation?) </span>
                    <textarea id="txtRiskOfHarm" name="txtRiskOfHarm" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Functional Status</span>
                    <span className="small block">(how has the Individual's behaviors/symptoms affected his/her ability to take care of daily tasks? i.e.
                        personal hygiene, school, work, community, personal/ family matters, etc.) </span>
                    <textarea id="txtFunctionalStatus" name="txtFunctionalStatus" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Medical Conditions</span>
                    <span className="small block">(does the Individual have any medical conditions that may contribute to the onset or progression of
                        the Presenting Problem? If so, please explain in detail the medical condition and how the Individual is affected.) </span>
                    <textarea id="txtMedicalConditions" name="txtMedicalConditions" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Environmental Stressors</span>
                    <span className="small block">(what are some concerns within the Individual's home, school, community and/or work
                        environment that may have contributed to the onset or progression of the Presenting Problem? i.e., new home, several residences
                        within the home, bulling at school/home, lost child syndrome, etc. Please explain concerns in detail.) </span>
                    <textarea id="txtEnvironmentalStressors" name="txtEnvironmentalStressors" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Environmental Support</span>
                    <span className="small block">:(please identify specific people, places or things which the Individual may rely on for
                        emotional, spiritual, or physical support. You may also include any community resources in which the Individual may engage in
                        to help alleviate his/her presenting problem.) </span>
                    <textarea id="txtEnvironmentalSupport" name="txtEnvironmentalSupport" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Response to Treatment</span>
                    <span className="small block">(please indicate if the Individual's response to treatment is Minimal, Moderate or
                        Significant. If his/her response is Minimal, please indicate how the treatment plan will be adjusted to help improve his/her
                        response to treatment.) </span>
                    <textarea id="txtTxResponse" name="txtTxResponse" className="add-only "></textarea></p>
                <p>
                    <span className="eleHeader">Acceptance and Engagement</span>
                    <span className="small block">(How well has the Individual accepted his/her responsibility for change? How has
                        he/she engaged in applying his/her treatment to daily living? What stage of change is the Individual currently in:
                        PreContemplative, Contemplative, Preparation, Action or Maintenance? If the Individual is in any stage less than Maintenance,
                        what steps are recommended that he/she take to reach the next Stage of Change?) </span>
                    <textarea id="txtAcceptance" name="txtAcceptance" className="add-only "></textarea></p>
                <p>

                    <span className="eleHeader">Verifiable Diagnosis:</span>
                    <span className="small block">(to be completed by office staff) </span>
                    <textarea id="txtVerifiable" name="txtVerifiable" className="add-only "></textarea>
                </p>










            </div>
        </form>
    )
}